import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import { logoutUser } from "../redux/slices/authSlice";
import { logoutgeneral } from "../redux/slices/generalSlice"
import { logoutdashboard } from "../redux/slices/dashboardSlice";
import { logoutnewapplicant } from "../redux/slices/newApplicantsSlice";
import { logoutreport } from "../redux/slices/reportSlice";
import { logoutTable } from "../redux/slices/tablesSlice";
import { authServie } from "../services/authService";

const useLogout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleLogOut = async () => {
        try {
          await authServie.logout(); // Call the logout API
    
          // Dispatch logout actions to clear Redux store
          dispatch(logoutUser());
          dispatch(logoutgeneral());
          dispatch(logoutdashboard());
          dispatch(logoutnewapplicant());
          dispatch(logoutreport());
          dispatch(logoutTable());
    
          // Clear localStorage
          localStorage.clear();
    
          // Show success message
          toast.success("You have successfully logged out");
    
          // Navigate to home page
          navigate("/");
        } catch (error) {
          toast.error("Logout failed. Please try again.");
          console.error("Logout error:", error);
        }
      };

    return {
        handleLogOut,
    };
};

export default useLogout;
